import { createSlice } from "@reduxjs/toolkit";
import { clientsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const clientsSlice = createSlice({
  name: "clients",
  initialState: data,
  reducers: {
    clientsSlice(state) {
      state.isLoading = false;
    },
    clientsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    clientsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    clientsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const clientsHandler = () => async (dispatch: any) => {
  try {
    dispatch(clientsAction.clientsSlice());
    const response: any = await clientsAPI();
    dispatch(clientsAction.clientsSliceSuccess(response));
  } catch (e: any) {
    dispatch(clientsAction.clientsSliceFailure(e?.response?.data?.message));
    dispatch(clientsAction.clientsSliceReset());
  }
};
export default clientsSlice.reducer;
export const clientsAction = clientsSlice.actions;
